import { useEffect, useState } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";

const ROUTE_ARG = "route";

export default function RouteFromArg() {
	const [queryParams] = useSearchParams();
	const navigate = useNavigate();
	const [wasRouteChecked, setWasRouteChecked] = useState(false);

	useEffect(() => {
		if (queryParams.size > 0) {
			const route = queryParams.get(ROUTE_ARG);
			if (route) {
				queryParams.delete(ROUTE_ARG);
				const reroute =
					queryParams.size === 0 ? route : `${route}/?${queryParams.toString()}`;
				navigate(reroute);
			}
		}
		setWasRouteChecked(true);
	}, []);

	if (!wasRouteChecked) return null;
	return <Outlet />;
}
